export default __webpack_public_path__ + "static/media/WalletsLogo2.dfd89373.png";